import Vue from "vue"
import Vuetify from "vuetify"
import "vuetify/dist/vuetify.min.css"

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#ff505c",
        secondary: "#5FB7D1",
        accent: "#0e264a"
      }
    }
  }
})
